import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { Action } from '@swf/core/types/Wizard';

import SignupOffer from '../../Signup/components/SignupOffer/SignupOffer';
import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFDOB from '../components/RMFDOB/RMFDOB';
import RMFLegalName from '../components/RMFLegalName/RMFLegalName';
import RMFStandaloneFinalPage from '../components/RMFStandaloneFinalPage/RMFStandaloneFinalPage';

import { Guard } from './useRmfGuards';
import { Service } from './useRmfServices';

const useRMFBaseSteps = () => {
  const exitWizard = useWizardExit();

  const jumpToFeatureStep = {
    name: 'jumpToFeatureStep',
    entry: Action.GoJump
  };

  const forkSignupDepositCheckDone: Fork = new Fork(
    Guard.SignupDepositEnabled,
    [{ name: 'rmfExit', entry: Action.GoNext }],
    [SignupOffer]
  );

  const invokeRmfDobUpdate: Invoke = new Invoke(Service.RmfDobUpdate, RMFLegalName, RMFDOB);

  const forkDobCheck: Fork = new Fork(
    Guard.RmfDobEnabled,
    [RMFDOB, invokeRmfDobUpdate, RMFLegalName],
    [RMFLegalName]
  );

  const invokeFetchLossLimits: Invoke = new Invoke(
    Service.RmfFetchApprovedLossLimits,
    forkDobCheck
  );

  const invokeFetchUserDepositLimit: Invoke = new Invoke(
    Service.RmfFetchUserDepositLimit,
    invokeFetchLossLimits
  );

  const invokeSignupDob: Invoke = new Invoke(Service.SignupDobFetch, forkDobCheck);

  const forkJumpToFeature: Fork = new Fork(
    Guard.DoesJumpToFeatureStep,
    [new Invoke(Service.SetJumpCreator, jumpToFeatureStep)],
    [forkSignupDepositCheckDone]
  );

  const createForkRmfExit = (): Fork =>
    new Fork(
      Guard.StandaloneRmf,
      [
        RMFStandaloneFinalPage,
        {
          name: 'exitRMF',
          entry: exitWizard,
          type: 'final'
        }
      ],
      [forkJumpToFeature]
    );

  const forkRmfExit: Fork = createForkRmfExit();

  const invokeLegalNameSave: Invoke = new Invoke(
    Service.RmfLegalNameSave,
    RMFAddress,
    RMFLegalName
  );

  const invokeDepositLimitSave: Invoke = new Invoke(Service.RmfDepositLimitSave, forkRmfExit);

  const forkDepositLimits: Fork = new Fork(Guard.LimitsSelected, forkRmfExit, [
    invokeDepositLimitSave
  ]);

  const invokeNetLimitSave: Invoke = new Invoke(Service.RmfLossLimitSave, forkRmfExit);

  const forkNetLossLimits: Fork = new Fork(Guard.LimitsSelected, forkRmfExit, [invokeNetLimitSave]);

  return {
    exitWizard,
    forkDepositLimits,
    forkDobCheck,
    forkJumpToFeature,
    forkNetLossLimits,
    forkRmfExit,
    forkSignupDepositCheckDone,
    invokeDepositLimitSave,
    invokeFetchLossLimits,
    invokeFetchUserDepositLimit,
    invokeLegalNameSave,
    invokeNetLimitSave,
    invokeRmfDobUpdate,
    invokeSignupDob,
    jumpToFeatureStep
  };
};

export default useRMFBaseSteps;
